import { useContext } from "react";
import { Context } from "./LanguageWrapper";

type Props = {
  /** Extra class on the wrapper (e.g. spacing in headers). */
  className?: string;
  /** Light text for dark headers (home / common header). */
  variant?: "light" | "dark";
};

const LanguageSwitcher = ({ className = "", variant = "dark" }: Props) => {
  const { locale, selectLanguage } = useContext(Context);

  return (
    <div
      className={`language-switcher language-switcher--${variant} ${className}`.trim()}
      role="group"
      aria-label="Language"
    >
      <select
        className="form-select form-select-sm language-switcher__select"
        value={locale === "alb" ? "alb" : "en"}
        onChange={(e) => selectLanguage(e.target.value)}
        aria-label="Select language"
      >
        <option value="en">English</option>
        <option value="alb">Shqip</option>
      </select>
    </div>
  );
};

export default LanguageSwitcher;
